export default __webpack_public_path__ + "static/media/Antonio Maresca.95ddbba9.jpg";